import React__default from 'react';
import { Wrapper, AnimatedBox } from './styles.js';

/**
 * Skeleton states are simplified versions of components used on an initial page load to indicate that the information on the page has not fully loaded yet.
 *
 * They should only appear for only a few seconds, disappearing once components and content populate the page.
 *
 */
const Skeleton = ({
  children,
  height,
  width,
  appearance,
  testId,
  sx: sxProp,
  animated = true,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(AnimatedBox, {
    height: height,
    width: width,
    appearance: appearance,
    animated: animated,
    "data-testid": testId,
    sx: sxProp
  }, children)));
};
Skeleton.displayName = 'Skeleton';
var Skeleton$1 = Skeleton;

export { Skeleton$1 as default };
